<template>
  <paginated-content :items="sessions" :perPage="pageSize" :parent-id="parentId">
    <template v-slot="{ displayItems }">
      <div class="sessions-list">
        <div v-for="{ type, value } in displayItems" :key="`${type}-${value.id}`">
          <agenda-session
            @open-user-modal="$emit('open-user-modal', $event)"
            @open-auth="$emit('open-auth')"
            @open-agenda-session-attendees="$emit('open-agenda-session-attendees', $event)"
            @open-agenda-session-questions="$emit('open-agenda-session-questions', $event)"
            @open-auth-lw-stream="$emit('open-auth-lw-stream', $event)"
            v-if="type === 'session'"
            :session="value"
            :session-ratings="sessionRatings"
            :hide-session-time="hideSessionTime"
            :show-live-indicator="showLiveIndicator"
            :hide-live-stream-buttons="hideLiveStreamButtons"
            :customSponsor="getCustomSponsor(value.id)"
          ></agenda-session>
          <agenda-meeting v-else-if="type === 'meeting'" :meeting="value"></agenda-meeting>
        </div>
      </div>

    </template>
  </paginated-content>
</template>

<script>
import PaginatedContent from "@/shared/components/common/pagination/PaginatedContent";
import AgendaSession from "@/widgets/agenda/components/sessions/AgendaSession";
import AgendaMeeting from "@/widgets/agenda/components/sessions/AgendaMeeting";

export default {
  name: "AgendaSessionsPagerView",

  props: {
    sessions: {
      type: Array,
    },

    sessionRatings: {
      type: Array,
    },

    hideDays: {
      type: Boolean,
    },

    hideSessionTime: {
      type: Boolean,
    },

    showLiveIndicator: {
      type: Boolean,
    },

    pageSize: {
      type: Number,
    },

    hideLiveStreamButtons: {
      type: Boolean,
    },
    customSponsors: {
      type: String,
    },

    parentId: {
      type: String,
    }
  },

  components: {
    PaginatedContent,
    AgendaSession,
    AgendaMeeting,
  },

  computed: {
    parsedSponsors() {
      return this.customSponsors && JSON.parse(this.customSponsors);
    },
  },

  methods: {
    getCustomSponsor(agendaSessionId) {
      return this.parsedSponsors && this.parsedSponsors.find(item => item.agenda_session_id === agendaSessionId);
    },
  },
};
</script>
